exports.default = "WebpackMultiOutput-/home/runner/work/web/web/static/nls/product-card.js-WebpackMultiOutput";